export default __webpack_public_path__ + "static/media/denizc4.8def9382.jpg";